import React from 'react'
import users from '@services/users'
import { alertPopup } from '@utils/popup'

class UpdateMentor extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: true,
            inputValue: ''
        }
    }

    componentDidMount() {
        if (this.props.agentInfo.mentor) {
            this.setState({ edit: false })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.agentInfo.mentor !== this.props.agentInfo.mentor) {
            if (this.props.agentInfo.mentor) {
                this.setState({ edit: false, inputValue: this.props.agentInfo.mentor })
            } else {
                this.setState({ edit: true })
            }
        }
    }

    handleUpdateMentor = () => {
        const { inputValue } = this.state
        if (inputValue.length < 2) alertPopup({ type: 'alert', title: 'שם המנטור קצר מדי', body: '' })
        else {
            users
                .updateMentor({ id: this.props.agentInfo.id, mentor: inputValue })
                .then(() => {
                    this.props.updateInfo()
                    this.setState({ edit: false })
                })
                .catch(err => {
                    if (err) {
                        alertPopup({ type: 'error', title: 'שגיאה בעדכון שם המנטור', body: '' })
                    }
                })
        }
    }

    render() {
        const { agentInfo = {}, roles = [] } = this.props
        const { mentor } = agentInfo
        const { inputValue, edit } = this.state

        return (
            <div style={{ display: 'flex' }}>
                <div style={{ ...style.box, ...style.rightBox }}>
                    {edit && (
                        <input
                            value={inputValue}
                            placeholder={'הזינו שם מנטור'}
                            onChange={e => this.setState({ inputValue: e.target.value })}
                            style={{ ...style.inputStyle }}
                        />
                    )}
                    {!edit && <span>{`מנטור: ${mentor}`}</span>}
                </div>

                {edit && (
                    <>
                        {mentor && (
                            <div
                                onClick={() => this.setState({ edit: false, inputValue: mentor })}
                                style={{ ...style.box }}
                            >
                                {'ביטול'}
                            </div>
                        )}
                        <div onClick={this.handleUpdateMentor} style={{ ...style.box, ...style.leftBox }}>
                            {<span>{'עדכון מנטור'}</span>}
                        </div>
                    </>
                )}

                {!edit && roles.includes('admin') && (
                    <div onClick={() => this.setState({ edit: true })} style={{ ...style.box, ...style.leftBox }}>
                        <span>{'עריכה'}</span>
                    </div>
                )}
            </div>
        )
    }
}

const style = {
    inputStyle: {
        border: 'solid rgb(209, 209, 209) 1px',
        borderRadius: '2px'
    },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    rightBox: { borderRadius: '0 4px 4px 0', cursor: 'default' },
    leftBox: { borderRadius: '4px 0 0 4px' }
}

export default UpdateMentor
